export function initMenu() {
  const burger = document.querySelector(".c-header__burger");
  const nav = document.querySelector(".c-header__nav");
  if (!burger || !nav) return;

  const setOpen = (open) => {
    nav.dataset.open = String(open);
    burger.setAttribute("aria-expanded", String(open));
    burger.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");
    if (open) nav.querySelector("a, button")?.focus();
  };

  burger.addEventListener("click", () => setOpen(nav.dataset.open !== "true"));

  // Fermeture sur clic d'un lien
  nav.addEventListener("click", (e) => {
    if (e.target.matches("a")) setOpen(false);
  });

  // Fermeture sur Échap (focus rendu au burger)
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && nav.dataset.open === "true") {
      setOpen(false);
      burger.focus();
    }
  });

  // Fermeture sur clic en dehors du header
  document.addEventListener("click", (e) => {
    if (nav.dataset.open === "true" && !e.target.closest(".c-header")) {
      setOpen(false);
    }
  });
}
